import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';

import LazyImage from '../LazyImage';

import style from './style';
import ActiveLink from '../ActiveLink';

const Hero = ({ data }) => {
  const classes = style();

  return (
    <ActiveLink href={data?.url}>
      <Box className={classes.section}>
        <div className={classes.overlap}></div>
        <Container>
          <div className={`${classes.absWrapper}`}>
            <div className={classes.textBox}>
              <div>
                <Typography variant="h2" component="h1">
                  {data && data.title[0]}

                  {data.title[1] && (
                    <>
                      <br /> {data.title[1]}
                    </>
                  )}
                  {data.title[2] && (
                    <>
                      <br /> {data.title[2]}
                    </>
                  )}
                </Typography>

                {data?.description && (
                  <Typography variant="body2" className={classes.paraContent}>
                    {data.description}
                  </Typography>
                )}
              </div>
            </div>
          </div>
        </Container>{' '}
        <Grid item className={classes.coverImg}>
          {data && data.bgImg && (
            <LazyImage
              sizes={sizes}
              src={`/images/${data.bgImg}`}
              alt={data.imgAlt}
            />
          )}
        </Grid>
      </Box>
    </ActiveLink>
  );
};
const sizes = {
  xs: [360, 448, false],
  sm: [768, 469, false],
  md: [1024, 469, false],
  xxl: [1920, 393, false],
};

export default Hero;
